import React, { Fragment, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { CSVError, processCsvFile } from '../../../../Utils/Misc'
import { Dropzone } from '../../../../Components/Form'
import { ModalHeader } from '../../../../Components/Modal/ModalHeader'
import { ModalTitle } from '../../../../Components/Modal/ModalTitle'
import { ModalBody } from '../../../../Components/Modal/ModalBody'
import { ModalFooter } from '../../../../Components/Modal/ModalFooter'
import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import LinearProgressBar from '../../../../Components/LinearProgressBar'

const ImportCityMetricsView = props => {
  const [file, setFile] = useState(null)
  const [errors, setErrors] = useState([])
  const [progress, setProgress] = useState(null)

  const onProgress = ({ processedAmount, totalAmount }) => {
    setProgress((processedAmount / totalAmount) * 100)
  }

  const onUploadFile = entryFiles => {
    let file = null
    if (typeof entryFiles[0] === 'undefined') {
      // Windows env
      const input = document.querySelector(
        '#ImportCityMetricsViewDropZoneContainer input',
      )
      if (!input) return null
      file = input.files.length && input.files[0]
    } else {
      file = entryFiles[0]
    }
    if (!file) return null
    setFile(file)
  }
  const processFile = async () => {
    if (!file) return
    const csvData = await processCsvFile(file)

    const errors = []
    const cityMetricsDtos = csvData.data.filter((d, i) => {
      // If all cells are empty then skip it
      const emptyRow = Object.keys(d).every(key => d[key].trim() == '')
      if (emptyRow) return false
      // It would be rude not to validate since we're here
      try {
        props.validateRow(d)
      } catch (e) {
        const csvError = new CSVError(e.message, i + 2)
        csvError.suggestion = e.suggestion
        errors.push(csvError)
      }
      return true
    })
    if (errors.length) return setErrors(errors)

    props.onImportSuccess(cityMetricsDtos, onProgress)
  }

  return (
    <Fragment>
      <ModalHeader>
        <ModalTitle>Import City Metrics</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <React.Fragment>
          <Row>
            <Col xs={6}>
              <a
                href="javascript:;" // eslint-disable-line
                onClick={props.downloadSampleCSV}
              >
                Download the csv template
              </a>
              <br />
              <br />
              <div>
                <div>No currency sign in the costs.</div>
                <div>Format: 10.5</div>
                <br />
                <div>No space in the numbers. </div>
                <div>Format: 1000</div>
                <br />
                <div>Use dot for decimals, not comma.</div>
                <div>Format: 1000.00</div>
              </div>
            </Col>
            <Col xs={6}>
              <div
                id="ImportCityMetricsViewDropZoneContainer"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Dropzone
                  mainLabel="City Metrics File"
                  input={{
                    value: '',
                    onChange: onUploadFile,
                  }}
                  meta={{}}
                />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      </ModalBody>
      {errors.length ? (
        <ImportCityMetricsErrorsView
          errors={errors}
          onOkay={() => setErrors([])}
        />
      ) : null}
      {progress ? (
        <LinearProgressBar
          variant="determinate"
          value={progress}
          showValue={true}
          isLoading={false}
          styles={{
            paddingTop: 40,
            marginRight: 8,
          }}
        />
      ) : null}
      <ModalFooter>
        <SubmitButton value="cancel" onClick={props.onClose} />
        <SubmitButton
          value="Confirm"
          onClick={processFile}
          disabled={errors.length !== 0}
        />
      </ModalFooter>
    </Fragment>
  )
}

const ImportCityMetricsErrorsView = props => {
  return (
    <Fragment>
      <ModalBody>
        <h4>Import Failed</h4>
        <p>Please review the below the lines that have an error:</p>
        {props.errors.map(err => {
          validateCSVError(err)
          return (
            <div key={err.lineNumber} className="modal-error-line">
              <p>
                <strong>Line {err.lineNumber || 'N/A'}: </strong>{' '}
                <small>{err.message}</small>
              </p>
              {err.suggestion && (
                <p>
                  <em>
                    <strong>{err.suggestion}</strong>
                  </em>
                </p>
              )}
            </div>
          )
        })}
      </ModalBody>
    </Fragment>
  )
}

const validateCSVError = function(error) {
  if (error instanceof CSVError === false)
    throw new Error("Error is not an 'import City Metrics error object.")
}

export default ImportCityMetricsView
